import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import type {
  IAssetHealthCauseCategoryList,
  IUseAssetHealthCauseCategoryListKeys,
} from '../model/assetHealthCauseCategoryList';

const assetHealthCauseCategoryListKey = (
  keys: IUseAssetHealthCauseCategoryListKeys,
): [string, Array<number> | undefined, ITableSorting, string | number | undefined] => [
  'assetHealthCauseCategoryList',
  keys.locationIds,
  keys.sorting,
  keys.urgency,
];

const assetHealthCauseCategoryListFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof assetHealthCauseCategoryListKey>, number>) => {
  const orderBy = queryKey[2].id ? queryKey[2].id : undefined;
  const direction = !queryKey[2].id ? undefined : queryKey[2].desc ? 'desc' : 'asc';

  const params = {
    location_ids: queryKey[1],
    sort: {
      field: orderBy,
      direction: direction,
    },
    urgency: queryKey[3] === 'all' ? undefined : queryKey[3],
  };

  return apiClient.get<{ data: IAssetHealthCauseCategoryList[] }>(
    `${APP_API_URL_V2}fsd/action-item/asset-health/failure-cause-categories`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

export const useAssetHealthCauseCategoryListQuery = (keys: IUseAssetHealthCauseCategoryListKeys) => {
  return useQuery({
    queryKey: assetHealthCauseCategoryListKey(keys),
    queryFn: assetHealthCauseCategoryListFn,
    select: ({ data }: AxiosResponse<{ data: IAssetHealthCauseCategoryList[] }>) => {
      if (!data.data) {
        return [];
      }
      return data.data;
    },
  });
};
